// extracted by mini-css-extract-plugin
module.exports = {"pt-hospital-table":"pt-hospital-table-f69ac561ceaf0081727cc8667a24fd20"};